import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Divider, Form, Progress, Radio, Space, Input } from 'antd';
import React from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import IconNoData from '../../../../../assets/Images/icons/icon-no-data';
import Sticky from 'react-sticky-el';
import { useState, useEffect } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { SearchOutlined } from '@ant-design/icons';

export default function Step2(props) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { currentProgress, consentGroupList, setConsent } = props;
    const [form] = useForm();
    const [searchValue, setSearchValue] = useState();
    const [filteredConsents, setFilteredConsents] = useState([]);

    const onPreviousStep = () => {
        props.calProgress(50);
        props.previousStep();
    };

    const searchTempleteList = async (value) => {
        if (value) {
            const filtered = consentGroupList.filter((consent) => {
                const consentNameEn = consent.consentNameEn || '';
                const consentNameTh = consent.consentNameTh || '';

                const searchValueLower = value?.toLowerCase();
                const consentNameEnLower = consentNameEn.toLowerCase();
                const consentNameThLower = consentNameTh.toLowerCase();

                return (
                    consentNameEnLower.includes(searchValueLower) ||
                    consentNameThLower.includes(searchValueLower)
                );
            });

            setFilteredConsents(filtered);
        } else {
            setFilteredConsents((prevConsents) => [...consentGroupList]);
        }
    };

    useEffect(() => {
        if (consentGroupList && consentGroupList.length > 0) {
            setFilteredConsents([...consentGroupList]);
        }
    }, [consentGroupList]);

    useEffect(() => {
        searchTempleteList(searchValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    return (
        <div>
            <Sticky
                boundaryElement=".block_"
                stickyClassName="bg-white p-4 shadow rounded-lg z-50"
            >
                <Button
                    size="large"
                    className="!border-purple !text-purple"
                    onClick={onPreviousStep}
                >
                    <ArrowLeftOutlined /> {t('Consent.Previous Step')}
                </Button>
            </Sticky>
            <Divider className="my-4" />
            <div className="flex item-center gap-x-3">
                <div>{LogoStep2}</div>
                <div>
                    <div className="font-medium text-base text-[#65707A]">
                        {t('MyTask.Step')} 2 / 2
                    </div>
                    <div className="font-semibold text-xl text-[#171717]">
                        {t('Consent.TermStep2')}
                    </div>
                </div>
            </div>
            <div>
                <Progress
                    strokeColor={{
                        '0%': '#C2BAFF',
                        '100%': '#7B67FB',
                    }}
                    percent={currentProgress}
                    status="active"
                    showInfo={false}
                />
            </div>
            <div className=" w-full col-span-2">
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    className="mt-4"
                    form={form}
                    onValuesChange={(value) => {
                        setSearchValue(value?.keyword);
                    }}
                >
                    <Form.Item name={'keyword'} className={'m-0'}>
                        <Input
                            size="large"
                            placeholder={t('Consent.SearchPurpose')}
                            suffix={<SearchOutlined />}
                        />
                    </Form.Item>
                </Form>
            </div>
            {!filteredConsents || filteredConsents?.length <= 0 ? (
                <>
                    <div className="text-center text-sm space-y-2 my-32">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px] whitespace-pre-line">
                            {t('Consent.ConsentTermNoDaTa')}
                        </p>
                    </div>
                </>
            ) : (
                <>
                    <Form.Item
                        className="w-full consents mt-8"
                        name="consentTxnGroupId"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.validateSelect'),
                            },
                        ]}
                    >
                        <Radio.Group
                            className="w-full"
                            onChange={(e) => {
                                const id = e.target.value;
                                const consent = filteredConsents?.find(
                                    (item) => id === item?.consentTxnGroupId
                                );
                                setConsent(consent);
                            }}
                        >
                            <Space className="w-full" direction="vertical">
                                {filteredConsents?.map((item) => (
                                    <Radio
                                        className="bg-[#F4F6FC] px-4 pb-4 pt-8 rounded-md w-full"
                                        key={item?.consentTxnGroupId}
                                        value={item?.consentTxnGroupId}
                                    >
                                        <div
                                            className="text-sm font-semibold"
                                            style={{
                                                position: 'absolute',
                                                top: '8px',
                                                left: '17px',
                                            }}
                                        >
                                            {lang === 'en'
                                                ? item?.consentNameEn
                                                : item?.consentNameTh}
                                        </div>
                                        <div className="w-full line-clamp-3">
                                            {' '}
                                            {lang === 'th'
                                                ? parse(
                                                      item?.purposeTh || ''
                                                  ) || ''
                                                : parse(
                                                      item?.purposeEn || ''
                                                  ) || ''}
                                        </div>
                                    </Radio>
                                ))}
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                </>
            )}
        </div>
    );
}

const LogoStep2 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            strokeWidth="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M19.6516 36.0892V32.9851L26.9043 26.2697C27.5211 25.6728 28.0384 25.1356 28.4563 24.658C28.8807 24.1805 29.2024 23.7129 29.4213 23.2553C29.6402 22.791 29.7496 22.2902 29.7496 21.753C29.7496 21.1561 29.6136 20.6421 29.3417 20.2109C29.0698 19.7732 28.6983 19.4383 28.2274 19.2061C27.7565 18.9674 27.2226 18.848 26.6257 18.848C26.0022 18.848 25.4584 18.974 24.9941 19.226C24.5298 19.4781 24.1717 19.8395 23.9196 20.3104C23.6676 20.7813 23.5416 21.3418 23.5416 21.9918H19.4526C19.4526 20.6586 19.7544 19.5013 20.358 18.5197C20.9615 17.5381 21.8072 16.7786 22.8949 16.2414C23.9826 15.7042 25.2362 15.4355 26.6555 15.4355C28.1147 15.4355 29.3848 15.6942 30.4659 16.2115C31.5536 16.7223 32.3993 17.4319 33.0028 18.3406C33.6064 19.2492 33.9082 20.2905 33.9082 21.4645C33.9082 22.2339 33.7556 22.9933 33.4505 23.7428C33.1521 24.4922 32.6181 25.3246 31.8488 26.2399C31.0794 27.1485 29.995 28.2396 28.5955 29.513L25.6209 32.428V32.5673H34.1768V36.0892H19.6516Z"
            fill="white"
        />
    </svg>
);
